import { render } from "./HomeStart.vue?vue&type=template&id=6f009ee8&scoped=true"
import script from "./HomeStart.vue?vue&type=script&lang=js"
export * from "./HomeStart.vue?vue&type=script&lang=js"

import "./HomeStart.vue?vue&type=style&index=0&id=6f009ee8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f009ee8"]])

export default __exports__